module.exports = __webpack_public_path__ + "img/lock-alt-solid.a41704c9.svg";